const translationsUk = {
  uk: {
    login: {
      form: {
        welcome: 'З поверненням',
        to: 'Аналіз трекінгових даних',
        vendor: 'Авіаційні технології. Ми створюємо майбутнє',
        userName: 'Логін користувача',
        authorize: 'Увійти',
        password: 'Пароль',
        userUnexist: 'Користувача з указаними даними не знайдено'
      }
    },
    tracksTree: {
      apply: 'Застосувати',
      toolbar: {
        trackList: 'Перелік записів'
      },
      menuDropdown: {
        fileMenu: 'Меню',
        expand: 'Розгорнути',
        collapse: 'Згорнути',
        delete: 'Видалити',
        export: 'Експортувати',
        process: 'Обробити',
        removeSelection: 'Скасувати виділення',
        exportCoordinates: 'Вивантажити маршрут',
        events: 'Події',
        params: 'Параметри',
        templates: 'Шаблони'
      },
      trackTitle: {
        organization: 'Орг.',
        vehicle: 'Транспорт',
        name: 'Назва',
        startedAt: 'Початок треку',
        origin: 'Початок',
        destination: 'Кінець',
        previous: 'Попередня',
        next: 'Наступна',
        loading: 'Завантаження...',
        noRowsFound: 'Записів не знайдено',
        page: 'Сторінка',
        of: 'з',
        rows: 'рядків',
      },
      trackControls: {
        confirm: 'Підтвердіть видалення треку',
      },
      folderControls: {
        confirm: 'Підтвердіть видалення каталогу',
      },
    },
    tracksTable: {
      toolbar: {
        trackList: 'Перелік треків'
      },
      menuDropdown: {
        fileMenu: 'Меню',
        delete: 'Видалити',
        export: 'Експортувати',
        process: 'Обробити',
        removeSelection: 'Скасувати виділення',
        exportCoordinates: 'Вивантажити маршрут',
        events: 'Події',
        params: 'Параметри',
        templates: 'Шаблони'
      },
      table: {
        vehicle: 'Транспорт',
        name: 'Назва',
        organization: 'Організація',
        startedAt: 'Початок треку',
        origin: 'Початок',
        destination: 'Кінець'
      }
    },
    uploadingPreview: {
      toolbar: {
        preview: 'Попередній перегляд'
      }
    },
    settings: {
      list: {
        options: 'Користувацькі налаштування',
        save: 'Зберегти',
        printTableStep: 'Крок цифрового друку',
        mainChartColor: 'Заливка графіка',
        lineWidth: 'Товщина ліній на графіку',
        trackShowAction: 'Дія із записом за замовчуванням',
        pointsMaxCount: 'Максимальна кількість точок на графіку'
      }
    },
    trackStatistics: {
      toolbar: {
        aggregatedStatistics: 'Агрегована статистика',
      },
      trackFilter: {
        trackInfoFilter: 'Фільтр за даними треку',
        apply: 'Застосувати',
        recorderType: 'Тип реєстратора',
        vehicle: 'Номер транспорту',
        name: 'Назва',
        origin: 'Початок',
        destination: 'Кінець',
        departureFromDate: 'Від дати відправлення',
        departureToDate: 'До дати відправлення'
      },
      paramsFilter: {
        apply: 'Застосувати',
        putTrackFilter: 'Задайте параметри фільтра',
        noMonitoredParamsOnSpecifyedFilter: 'Немає відстежуваних параметрів за вказаним фільтром',
        monitoredParameters: 'Відстежувані параметри',
      },
      values: {
        results: 'Результати',
        setParamsForReportGenerating: 'Задайте параметри для формування результатів',
        noDataToGenerateReport: 'Немає даних для формування результатів',
      },
      valuesRow: {
        title: 'Параметр',
        count: 'Кількість',
        min: 'Мін',
        avg: 'Середнє',
        sum: 'Сума',
        max: 'Макс',
      },
    },
    trackTemplates: {
      item: {
        events: 'Події',
        default: 'За замовчуванням',
        last: 'Останній перегляд'
      }
    },
    trackEvents: {
      formPrint: {
        grayscale: 'Ч/Б'
      },
      trackComment: {
        operatorAdmitted: 'Оператор допущений',
        vehicleAllowed: 'Транспорт допущено',
        generalAdmission: 'Загальний допуск',
        save: 'Зберегти'
      },
      title: {
        recorderName: 'Тип реєстратора',
        vehicle: 'Транспорт',
        name: 'Назва',
        startedAt: 'Початок запису треку',
        origin: 'Початок',
        destination: 'Кінець',
        centringto: 'Центрування на зльоті',
        centringlndg: 'Центрування на посадці',
        weightto: 'Вага на зльоті',
        weightlndg: 'Вага на посадці',
        tto: 'Тнп на зльоті',
        operator: 'Оператор',
        route: 'Маршрут',
        centring: 'Центрування',
      },
      list: {
        processingNotPerformed: 'Обробку не виконано',
        noEvents: 'Події не зафіксовано'
      },
      collapse: {
        eventCodeMask000: 'Технологічні повідомлення',
        eventCodeMask001: 'Контроль техніки пілотування',
        eventCodeMask002: 'Контроль працездатності',
        eventCodeMask003: 'Інформаційні повідомлення',
      },
      contentHeader: {
        start: 'Початок',
        end: 'Кінець',
        duration: 'Тривалість',
        code: 'Код',
        eventName: 'Назва',
        algorithm: 'Алгоритм',
        aditionalInfo: 'Дод. інф.',
        reliability: 'Достов.',
        comment: 'Коментар',
      }
    },
    calibration: {
      toolbar: {
        title: 'Градуювання'
      },
      table: {
        recorder: 'Тип реєстратора',
        name: 'Назва',
        dateCreation: 'Дата створення',
        dateLastEdit: 'Дата останнього редагування',
        confimDeleting: 'Підтвердіть видалення градуювання'
      },
      create: 'Створити',
      creationForm: 'Форма створення градуювання',
      for: 'для',
      paramName: 'Назва',
      paramCode: 'Код',
      paramChannels: 'Канали',
      valueAdd: 'Додати',
      save: 'Зберегти',
      update: 'Оновити',
      list: 'До списку',
      unexist: 'Градуювання відсутні',
      controls: 'Керування',
      edit: 'Редагувати',
      delete: 'Видалити',
      inputName: 'Введіть назву калібрування для збереження'
    },
    calibrationForm: {
      toolbar: {
        title: 'Градуювання для %{recorderName}'
      },
      spreadsheetTitle: {
        code: 'Код',
        physics: 'Фізика'
      },
      spreadsheet: {
        addButton: 'Додати рядок'
      },
      param: {
        code: 'Код параметра',
        name: 'Назва (о.в.)',
        channels: 'Канали',
        minValue: 'Мін. зн.',
        maxValue: 'Макс. зн.',
        deviationFromStandardView: 'Відхилення від стандартного вигляду'
      }
    },
    trackUploader: {
      upload: 'Завантажити',
      filesList: 'Перелік файлів',
    },
    usersTable: {
      toolbar: {
        list: 'Перелік користувачів',
      },
      table: {
        login: 'Логін',
        name: "Ім'я",
        email: 'Ел. пошта',
        phone: 'Тел.',
        lang: 'Мова',
        role: 'Роль',
        company: 'Організація',
        logo: 'Логотип',
        add: 'Створити',
        create: 'Створити',
        edit: 'Редагувати',
        delete: 'Видалити',
        list: 'Перелік',
        save: 'Зберегти',
        confimUserDeleting: 'Підтвердіть видалення користувачів',
        confimUserDeletion: 'Підтвердіть видалення користувачів'
      }
    },
    userForm: {
      toolbar: {
        create: 'Створення нового користувача',
        edit: 'Редагування користувача'
      },
      form: {
        login: 'Логін',
        name: "Ім'я",
        email: 'Ел. пошта',
        phone: 'Тел.',
        pass: 'Пароль',
        repeatPass: 'Повторіть пароль',
        company: 'Організація',
        role: 'Роль',
        logo: 'Логотип',
        avaliableRecorders: 'Доступ до типів реєстраторів',
        chooseFile: 'Виберіть файл',
        notAllNecessarySent: "Не всі обов'язкові поля заповнено (позначені *)",
        alreadyExist: 'Користувач із вибраним логіном уже існує',
        creationError: 'Помилка створення користувача'
      },
      roleRadio: {
        admin: 'Адміністратор',
        moderator: 'Модератор',
        user: 'Користувач'
      }
    },
    userActivity: {
      toolbar: {
        list: 'Список дій користувача',
      },
      table: {
        action: 'Дія',
        status: 'Статус',
        message: 'Відповідь сервера',
        date: 'Дата'
      }
    },
    supervision: {
      verticalToolbar: {
        connectionParams: "Параметри підключення",
        recorderType: 'Тип реєстратора',
        start: 'Пуск',
        stop: 'Стоп',
        save: 'Зберегти'
      },
      dataSource: {
        kvViaUdp: 'KV через UDP',
        file: 'Файл',
        fileViaUdp: 'Файл через UDP',
        connectionType: 'Тип підключення',
        sourceIps: 'IP-адреси джерел',
        addSource: 'Додати джерело',
        fakeData: 'Тестові дані',
        chooseFile: 'Вибрати файл',
        enterIpToConnect: 'Будь ласка, введіть IP для підключення'
      },
      chooseParamsButtons: {
        chooseSource: 'Виберіть спосіб задання параметрів',
        template: 'Шаблон',
        manual: 'Перелік',
        chooseParamsToShow: 'Виберіть параметри для відображення',
        containerParams: 'Показати перелік',
        chooseParamsToShowInContainer: 'Виберіть параметри для виведення значень',
        apply: 'Застосувати'
      },
      physics: {
        header: 'Фізичні значення параметрів',
        chooseParams: 'Виберіть параметри для спостереження'
      },
      binary: {
        header: 'Активні бінарні параметри'
      },
      events: {
        header: 'Результати логічного аналізу вхідних даних'
      },
      ungrouped: 'Поза групами'
    },
    chart: {
      threeDim: {
        model: {
          follow: 'Слідувати',
          freeCamera: 'Вільна камера',
        }
      }
    },
    topMenu: {
      brand: 'Vehiclesos',
      supervision: 'Супервізія',
      fileImport: 'Імпорт',
      upload: 'Завантаження',
      trackImporterDropdown: {
        fileImport: 'Імпортувати',
        chooseFile: 'Вибрати файл',
      },
      trackUploaderDropdown: {
        trackUploading: 'Завантаження треку',
        chooseFile: 'Вибрати файл',
        preview: 'Попередній перегляд',
        on: 'Увімк',
        off: 'Вимк',
      }
    },
    recorderSelector: {
      placeholder: 'Виберіть тип реєстратора'
    },
    recorderTemplateSelector: {
      placeholder: 'Виберіть шаблон',
      item: {
        default: 'За замовчуванням',
        last: 'Останній перегляд',
        events: 'Події',
      }
    },
    cycloParams: {
      colorPicker: {
        cancel: 'Скасувати',
        save: 'Зберегти'
      }
    },
    mainMenu: {
      tracks: 'Треки',
      recorders: 'Реєстратори',
      calibration: 'Градуювання',
      users: 'Користувачі',
      results: 'Результати',
      search: 'Пошук',
    },
    trackViewOptionsSwitch: {
      events: 'Події',
      params: 'Параметри',
      templates: 'Шаблони'
    },
    trackListViewSwitch : {
      treeView: 'Дерево',
      tableView: 'Таблиця',
    },
    trackTemplateEdit: {
      toolbar: {
        templates: 'Шаблони'
      },
      saveForm: {
        templateName: 'Назва шаблону'
      }
    },
    table: {
      previous: 'Попередня',
      next: 'Наступна',
      loading: 'Завантаження...',
      noRowsFound: 'Елементи не знайдено',
      page: 'Сторінка',
      of: 'з',
      rows: 'рядків',
    }
  }
};

export default translationsUk;
